import { apiFetchFull, api } from './client'
import type { Order } from './orders'

export interface Customer {
  id: number
  email: string
  username?: string
  company?: string
  phone?: string
  created_at: string
  updated_at: string
}

export interface CustomerListParams {
  search?: string
  min_id?: number
  limit?: number
  has_company?: boolean
}

export interface CustomerListResult {
  customers: Customer[]
  has_more: boolean
  next_min_id?: number
}

export async function listCustomers(params: CustomerListParams = {}): Promise<CustomerListResult> {
  const qs = new URLSearchParams()
  if (params.search) qs.set('filter[q][contains]', params.search)
  if (params.has_company !== undefined) qs.set('filter[has_company]', String(params.has_company))
  if (params.min_id) qs.set('pagination[min_id]', String(params.min_id))
  qs.set('pagination[limit]', String(params.limit ?? 50))

  const res = await apiFetchFull<Customer[]>(`/customer/?${qs.toString()}`)
  return {
    customers: res.data ?? [],
    has_more: res.pagination?.has_more ?? false,
    next_min_id: res.pagination?.next_min_id as number | undefined,
  }
}

export async function getCustomer(id: string): Promise<Customer> {
  return api.get<Customer>(`/customer/${encodeURIComponent(id)}/`)
}

export async function getCustomerOrders(id: string): Promise<Order[]> {
  return api.get<Order[]>(`/customer/${encodeURIComponent(id)}/orders/`)
}
